export default __webpack_public_path__ + "static/media/branding-stat-1.d9fa8179.jpg";